import api from '@/shared/api';
import { buildTruthySearchParams, requestExcelBlobExport } from '@/shared/lib';

import { VALIDITY_HISTORY_EXPORT_GENERIC_RETRY_MESSAGE } from '../config/messages';
import { VALIDITY_HISTORY_DOCUMENT_EXPORT_URL } from '../config/validity-history-tabs.config';

export interface ValidityHistoryExportParams {
  term?: string;
  searchType?: 'name' | 'prefix';
  sort?: string;
  order?: string;
  documentType?: 'DOCUMENT' | 'REGISTRATION';
  status?: string;
  elaboratedBy?: string;
  approvedBy?: string;
  verifiedBy?: string;
  elaborationDate?: string;
  approvalDate?: string;
  verificationDate?: string;
  effectiveDate?: string;
  revision?: number;
}

const VALIDITY_HISTORY_QUERY_KEYS = [
  'term',
  'searchType',
  'sort',
  'order',
  'documentType',
  'status',
  'elaboratedBy',
  'approvedBy',
  'verifiedBy',
  'elaborationDate',
  'approvalDate',
  'verificationDate',
  'effectiveDate',
  'revision',
] as const satisfies readonly (keyof ValidityHistoryExportParams)[];

class ValidityHistoryApi {
  async exportValidityHistoryExcel(
    params: ValidityHistoryExportParams,
    exportUrl: string = VALIDITY_HISTORY_DOCUMENT_EXPORT_URL
  ): Promise<{ blob: Blob; exportedCount: number; filename: string }> {
    const queryParams = buildTruthySearchParams(params, VALIDITY_HISTORY_QUERY_KEYS);

    return requestExcelBlobExport(
      () => api.get(`${exportUrl}?${queryParams.toString()}`, { responseType: 'blob' }),
      'historico-vigencias.xlsx',
      VALIDITY_HISTORY_EXPORT_GENERIC_RETRY_MESSAGE
    )
  }
}

export const validityHistoryApi = new ValidityHistoryApi();
